'use client';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { SCROLL_TO_TOP_ON_NAVIGATE } from '../../../constants';

export const ScrollToTop: React.FC = () => {
    const pathname = usePathname();

    useEffect(() => {
        if (!SCROLL_TO_TOP_ON_NAVIGATE) return;
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [pathname]);

    return null;
};
